import { pointerHypot } from "./Pointer";
import { Side, Position } from "@/types";

export class ModalBody {
  side: Side;
  modalBodyElem: HTMLDivElement;
  modalContainerElem: HTMLDivElement;

  constructor(side: Side, modalBodyElem: HTMLDivElement, modalContainerElem: HTMLDivElement) {
    this.side = side;
    this.modalBodyElem = modalBodyElem;
    this.modalContainerElem = modalContainerElem;
  }

  getModalBodyPoistionLeft(ref: HTMLDivElement): Position {
    const refBoundingRect = ref.getBoundingClientRect();

    const left = refBoundingRect.left + refBoundingRect.width + pointerHypot / 2;
    const top = refBoundingRect.top;

    return {
      left: this.checkBodyLeftPosition(this.modalBodyElem, this.modalContainerElem, left),
      top: this.checkBodyTopPosition(this.modalBodyElem, this.modalContainerElem, top),
    };
  }

  getModalBodyPoistionTop(ref: HTMLDivElement): Position {
    const refBoundingRect = ref.getBoundingClientRect();

    const left = refBoundingRect.left;
    const top = refBoundingRect.top + refBoundingRect.height + pointerHypot / 2;

    return {
      left: this.checkBodyLeftPosition(this.modalBodyElem, this.modalContainerElem, left),
      top: this.checkBodyTopPosition(this.modalBodyElem, this.modalContainerElem, top),
    };
  }

  getModalBodyPoistionBottom(ref: HTMLDivElement): Position {
    const refBoundingRect = ref.getBoundingClientRect();
    const modalBodyBoundingRect = this.modalBodyElem.getBoundingClientRect();

    const left = refBoundingRect.left;
    const top = refBoundingRect.top - modalBodyBoundingRect.height - pointerHypot / 2;

    return {
      left: this.checkBodyLeftPosition(this.modalBodyElem, this.modalContainerElem, left),
      top: this.checkBodyTopPosition(this.modalBodyElem, this.modalContainerElem, top),
    };
  }

  checkBodyLeftPosition(
    modalBody: HTMLDivElement,
    modalContainer: HTMLDivElement,
    refPosition: number
  ): number {
    const modalBodyBR = modalBody.getBoundingClientRect();
    const modalContainerBR = modalContainer.getBoundingClientRect();

    if (refPosition + modalBodyBR.width > modalContainerBR.width) {
      const offSetX = modalContainerBR.width - (refPosition + modalBodyBR.width);
      return offSetX + refPosition;
    } else {
      return refPosition;
    }
  }

  checkBodyTopPosition(
    modalBody: HTMLDivElement,
    modalContainer: HTMLDivElement,
    refPosition: number
  ): number {
    const modalBodyBR = modalBody.getBoundingClientRect();
    const modalContainerBR = modalContainer.getBoundingClientRect();

    if (refPosition + modalBodyBR.height > modalContainerBR.height) {
      const offSetY = modalContainerBR.height - (refPosition + modalBodyBR.height);
      return offSetY + refPosition;
    } else {
      return refPosition;
    }
  }
}
